<template>
  <modal v-show="visible" footer @close="handleClose">
    <template v-slot:title>
      <h5>{{ title }}</h5>
    </template>
    <template v-slot:body>
      <div class="text-center">
        <p class="text-center">{{ description }}</p>
        <input
          type="text"
          v-model.trim="code"
          class="form-control"
          placeholder="Enter Code"
          maxlength="6"
          autocomplete="one-time-code"
          style="width: 200px; margin: 0 auto;"
          @keyup.enter="handleSubmit"
        />
      </div>
    </template>
    <template v-slot:footer>
      <button
        type="button"
        class="button mr-2"
        :disabled="loading"
        @click.prevent="handleClose"
      >
        Cancel
      </button>
      <button
        type="button"
        class="button"
        :disabled="loading || !code"
        @click.prevent="handleSubmit"
      >
        <span class="custom-loader" v-if="loading">
          <loader-icon size="1.5x" class="custom-class"></loader-icon>
          <span style="font-weight: 600; text-transform: initial;">{{ loadingText }}</span>
        </span>
        <span v-else>{{ submitLabel }}</span>
      </button>
    </template>
  </modal>
</template>

<script>
export default {
  name: "TwoFactorPrompt",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "2FA Verification"
    },
    description: {
      type: String,
      default:
        "For security, please enter a fresh code from your authenticator app."
    },
    submitLabel: {
      type: String,
      default: "Verify Code"
    },
    loadingText: {
      type: String,
      default: "Verifying..."
    }
  },
  data() {
    return {
      code: ""
    };
  },
  watch: {
    visible(value) {
      if (value) {
        this.code = "";
      }
    }
  },
  methods: {
    handleClose() {
      if (this.loading) {
        return;
      }

      this.code = "";
      this.$emit("close");
    },
    handleSubmit() {
      if (this.loading || !this.code) {
        return;
      }

      this.$emit("submit", this.code);
    }
  }
};
</script>
